export default "__VITE_ASSET__fc47fdfc__"